(function () {
  "use strict";

  var DATA = window.ENNEA_DATA;
  var KLAVIYO_COMPANY_ID = "SEHdjk";
  var KLAVIYO_LIST_ID = "R88rKd";

  var state = {
    lang: "fr",
    screen: "intro",
    index: 0,
    answers: new Array(DATA.questions.length).fill(0),
    firstname: "",
    email: "",
    scores: null,
    top: null
  };

  var root = document.getElementById("ennea-root");
  if (!root) return;

  function t(key) {
    return DATA.ui[state.lang][key] || key;
  }

  function fmt(str, vars) {
    return str.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ""; });
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function computeScores() {
    var sums = {};
    for (var i = 1; i <= 9; i++) sums[i] = 0;
    DATA.questions.forEach(function (q, idx) {
      var v = state.answers[idx] || 0;
      sums[q.type] += v;
    });
    return sums;
  }

  function getTypeById(id) {
    for (var i = 0; i < DATA.types.length; i++) if (DATA.types[i].id === id) return DATA.types[i];
    return null;
  }

  function computeResult() {
    var sums = computeScores();
    var maxScore = -1, topId = 1;
    Object.keys(sums).forEach(function (k) {
      if (sums[k] > maxScore) { maxScore = sums[k]; topId = parseInt(k, 10); }
    });
    var topType = getTypeById(topId);

    var leftId = topType.wings.left, rightId = topType.wings.right;
    var leftScore = sums[leftId], rightScore = sums[rightId];
    var wingId = rightScore >= leftScore ? rightId : leftId;

    var centerSums = { gut: 0, heart: 0, head: 0 };
    DATA.types.forEach(function (ty) { centerSums[ty.center] += sums[ty.id]; });
    var topCenter = "gut", maxC = -1;
    Object.keys(centerSums).forEach(function (c) {
      if (centerSums[c] > maxC) { maxC = centerSums[c]; topCenter = c; }
    });

    return { sums: sums, topType: topType, wingId: wingId, centerSums: centerSums, topCenter: topCenter };
  }

  function render() {
    if (state.screen === "intro") return renderIntro();
    if (state.screen === "quiz") return renderQuiz();
    if (state.screen === "gate") return renderGate();
    if (state.screen === "result") return renderResult();
  }

  function renderIntro() {
    root.innerHTML =
      '<div class="ennea-card ennea-intro">' +
        "<h1 class=\"ennea-title\">" + t("pageTitle") + "</h1>" +
        "<p class=\"ennea-subtitle\">" + t("pageSubtitle") + "</p>" +
        "<p class=\"ennea-intro-text\">" + t("intro") + "</p>" +
        '<button type="button" class="ennea-btn ennea-btn-primary" id="ennea-start-btn">' + t("startBtn") + "</button>" +
      "</div>";
    document.getElementById("ennea-start-btn").addEventListener("click", function () {
      state.screen = "quiz";
      state.index = 0;
      render();
    });
  }

  function renderQuiz() {
    var total = DATA.questions.length;
    var q = DATA.questions[state.index];
    var current = state.answers[state.index] || 0;
    var pct = Math.round(((state.index) / total) * 100);

    var scaleHtml = "";
    for (var v = 1; v <= 5; v++) {
      var label = t("scale" + v);
      scaleHtml +=
        '<button type="button" class="ennea-scale-btn' + (current === v ? " is-selected" : "") + '" data-val="' + v + '">' +
          '<span class="ennea-scale-dot"></span>' +
          '<span class="ennea-scale-label">' + escapeHtml(label) + "</span>" +
        "</button>";
    }

    root.innerHTML =
      '<div class="ennea-card ennea-quiz">' +
        '<div class="ennea-progress-wrap" aria-label="' + t("progressLabel") + '">' +
          '<div class="ennea-progress-bar"><div class="ennea-progress-fill" style="width:' + pct + '%"></div></div>' +
        "</div>" +
        '<div class="ennea-qcounter">' + fmt(t("questionOf"), { n: state.index + 1, total: total }) + "</div>" +
        '<div class="ennea-question">' + escapeHtml(q[state.lang]) + "</div>" +
        '<div class="ennea-scale">' + scaleHtml + "</div>" +
        '<div class="ennea-nav">' +
          '<button type="button" class="ennea-btn ennea-btn-ghost" id="ennea-prev-btn"' + (state.index === 0 ? " disabled" : "") + ">" + t("prev") + "</button>" +
          '<button type="button" class="ennea-btn ennea-btn-primary" id="ennea-next-btn"' + (current === 0 ? " disabled" : "") + ">" + t("next") + "</button>" +
        "</div>" +
      "</div>";

    var scaleBtns = root.querySelectorAll(".ennea-scale-btn");
    scaleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.answers[state.index] = parseInt(btn.getAttribute("data-val"), 10);
        if (state.index < total - 1) {
          state.index += 1;
          render();
        } else {
          state.screen = "gate";
          render();
        }
      });
    });

    document.getElementById("ennea-prev-btn").addEventListener("click", function () {
      if (state.index > 0) { state.index -= 1; render(); }
    });
    document.getElementById("ennea-next-btn").addEventListener("click", function () {
      if (!state.answers[state.index]) return;
      if (state.index < total - 1) { state.index += 1; render(); }
      else { state.screen = "gate"; render(); }
    });
  }

  function renderGate() {
    root.innerHTML =
      '<div class="ennea-card ennea-gate">' +
        "<h2 class=\"ennea-title\">" + t("gateTitle") + "</h2>" +
        "<p class=\"ennea-subtitle\">" + t("gateSubtitle") + "</p>" +
        '<div class="ennea-field">' +
          "<label>" + t("firstname") + "</label>" +
          '<input type="text" id="ennea-firstname" autocomplete="given-name">' +
        "</div>" +
        '<div class="ennea-field">' +
          "<label>" + t("email") + "</label>" +
          '<input type="email" id="ennea-email" autocomplete="email">' +
        "</div>" +
        '<label class="ennea-consent-label">' +
          '<input type="checkbox" id="ennea-consent">' +
          '<span>' + escapeHtml(t("consent")) + "</span>" +
        "</label>" +
        '<div class="ennea-err" id="ennea-err" style="display:none">' + t("errRequired") + "</div>" +
        '<button type="button" class="ennea-btn ennea-btn-primary" id="ennea-gate-submit">' + t("seeResult") + "</button>" +
      "</div>";

    document.getElementById("ennea-gate-submit").addEventListener("click", function () {
      var fn = document.getElementById("ennea-firstname").value.trim();
      var em = document.getElementById("ennea-email").value.trim();
      var consent = document.getElementById("ennea-consent").checked;
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
      if (!fn || !emailOk || !consent) {
        document.getElementById("ennea-err").style.display = "block";
        return;
      }
      state.firstname = fn;
      state.email = em;
      var result = computeResult();
      state.scores = result;
      submitToKlaviyo(fn, em, result);
      state.screen = "result";
      render();
    });
  }

  function barsHtml(result) {
    var html = "";
    var maxPossible = 50;
    DATA.types.forEach(function (ty) {
      var score = result.sums[ty.id];
      var pct = Math.round((score / maxPossible) * 100);
      html +=
        '<div class="ennea-bar-row' + (ty.id === result.topType.id ? " is-top" : "") + '">' +
          '<div class="ennea-bar-label">' + escapeHtml(ty.name[state.lang]) + "</div>" +
          '<div class="ennea-bar-track"><div class="ennea-bar-fill" style="width:' + pct + '%"></div></div>' +
          '<div class="ennea-bar-pct">' + pct + "%</div>" +
        "</div>";
    });
    return html;
  }

  function renderResult() {
    var result = state.scores || computeResult();
    var top = result.topType;
    var wing = getTypeById(result.wingId);
    var center = DATA.centers[result.topCenter];
    var perfume = DATA.perfumes[top.id];

    var strengthsHtml = top.strengths[state.lang].map(function (s) {
      return "<li>" + escapeHtml(s) + "</li>";
    }).join("");

    var wingsHtml =
      '<div class="ennea-wing-card">' +
        "<strong>" + top.id + "w" + top.wings.left + "</strong> — " + escapeHtml(top.wingBlurb.left[state.lang]) +
      "</div>" +
      '<div class="ennea-wing-card">' +
        "<strong>" + top.id + "w" + top.wings.right + "</strong> — " + escapeHtml(top.wingBlurb.right[state.lang]) +
      "</div>";

    root.innerHTML =
      '<div class="ennea-card ennea-result" id="ennea-result-capture">' +
        '<div class="ennea-result-kicker">' + t("resultTitleLabel") + "</div>" +
        '<h1 class="ennea-result-title">' +
          '<span class="ennea-result-number">' + top.id + "</span> " + escapeHtml(top.name[state.lang]) +
        "</h1>" +
        '<p class="ennea-result-essence">' + escapeHtml(top.essence[state.lang]) + "</p>" +

        '<div class="ennea-result-grid">' +
          '<div class="ennea-result-block"><h3>' + t("motivationLabel") + "</h3><p>" + escapeHtml(top.motivation[state.lang]) + "</p></div>" +
          '<div class="ennea-result-block"><h3>' + t("fearLabel") + "</h3><p>" + escapeHtml(top.fear[state.lang]) + "</p></div>" +
          '<div class="ennea-result-block"><h3>' + t("strengthsLabel") + "</h3><ul>" + strengthsHtml + "</ul></div>" +
          '<div class="ennea-result-block"><h3>' + t("growthLabel") + "</h3><p>" + escapeHtml(top.growth[state.lang]) + "</p></div>" +
        "</div>" +

        '<div class="ennea-section-title">' + t("centerLabel") + "</div>" +
        '<div class="ennea-center-card"><strong>' + escapeHtml(center.name[state.lang]) + "</strong><p>" + escapeHtml(center.desc[state.lang]) + "</p></div>" +

        '<div class="ennea-section-title">' + t("wingsTitle") + "</div>" +
        '<div class="ennea-wings">' + wingsHtml + "</div>" +

        '<div class="ennea-section-title">' + t("perfumeTitle") + "</div>" +
        '<p class="ennea-perfume-intro">' + t("perfumeIntro") + "</p>" +
        '<a class="ennea-perfume-card" href="' + perfume.url + '" target="_blank" rel="noopener">' +
          '<img class="ennea-perfume-img" src="' + perfume.image + '" alt="' + escapeHtml(perfume.name) + '" loading="lazy">' +
          '<div class="ennea-perfume-info">' +
            '<div class="ennea-perfume-number">' + top.id + "</div>" +
            '<div class="ennea-perfume-name">' + escapeHtml(perfume.name) + "</div>" +
            '<span class="ennea-btn ennea-btn-primary ennea-perfume-btn">' + t("perfumeCta") + "</span>" +
          "</div>" +
        "</a>" +

        '<div class="ennea-section-title">' + t("breakdownTitle") + "</div>" +
        '<div class="ennea-bars">' + barsHtml(result) + "</div>" +

        '<div class="ennea-actions">' +
          '<button type="button" class="ennea-btn ennea-btn-ghost" id="ennea-pdf-btn">' + t("downloadPDF") + "</button>" +
          '<button type="button" class="ennea-btn ennea-btn-ghost" id="ennea-restart-btn">' + t("restart") + "</button>" +
        "</div>" +

        '<p class="ennea-disclaimer">' + t("disclaimer") + "</p>" +
      "</div>";

    document.getElementById("ennea-restart-btn").addEventListener("click", function () {
      state.screen = "intro";
      state.index = 0;
      state.answers = new Array(DATA.questions.length).fill(0);
      state.scores = null;
      render();
    });
    var pdfBtn = document.getElementById("ennea-pdf-btn");
    if (pdfBtn) pdfBtn.addEventListener("click", function () { downloadPDF(); });
  }

  function toggleLang() {
    state.lang = state.lang === "fr" ? "en" : "fr";
    var langBtn = document.getElementById("ennea-lang-btn");
    if (langBtn) langBtn.textContent = t("langToggle");
    render();
  }

  function submitToKlaviyo(firstname, email, result) {
    try {
      var body = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  first_name: firstname,
                  properties: {
                    enneagram_type: result.topType.id + "w" + result.wingId,
                    enneagram_name: result.topType.name.fr,
                    enneagram_center: result.topCenter
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: "list", id: KLAVIYO_LIST_ID } }
          }
        }
      };
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY_ID, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-10-15"
        },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }

  function downloadPDF() {
    var el = document.getElementById("ennea-result-capture");
    if (!el || !window.html2canvas || !window.jspdf) return;
    window.html2canvas(el, { scale: 2, useCORS: true }).then(function (canvas) {
      var imgData = canvas.toDataURL("image/png");
      var jsPDF = window.jspdf.jsPDF;
      var pdf = new jsPDF("p", "mm", "a4");
      var pageWidth = pdf.internal.pageSize.getWidth();
      var imgWidth = pageWidth;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var position = 0;
      var pageHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save("enneagramme-spiritum-paris.pdf");
    });
  }

  var heroLangBtn = document.getElementById("ennea-lang-btn");
  if (heroLangBtn) heroLangBtn.addEventListener("click", toggleLang);

  render();
})();
